import { combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { configureStore } from '@reduxjs/toolkit'
import { createBrowserHistory } from 'history';


import { AppStorage } from '../common/app-storage'
import { STORAGEKEYS } from '../common/keys'
import { applicationReducer, initialApplicationState } from './reducers/application-reducer'
import { contractSignIntialState, contractSignReducer } from './reducers/contract-sign-reducer'
import { consentReducer, intialStateConsent } from './reducers/consent-reducer';
import { SessionStorage } from '../common/cookie-storage';
import { offerReducer, offertInitialState } from './reducers/offert-reducer'
import { textContentReducer } from './reducers/text-contents-reducer'
import { lenConfigReducer, lenConfigInitialState } from './reducers/len-config-reducer'
import { defaultTextContents } from '../service/TextContentsService'
import { formReducer, formInitialState } from './reducers/form-reducer'
import { loanCalculatorInitialState, loanCalculatorReducer } from './reducers/loan-calculator-reducer'
import { videoVerificationInitialState, videoVerificationReducer } from './reducers/video-verification-reducer'
import { registerInvalidDocumentNumbersConfig } from '../common/invalidDocumentNumbersConfig'


export const saveCurrentState = (state : AppState)=>{
  const appStorage = new AppStorage();
  const sessionStorage = new SessionStorage();
  appStorage.clearStore();
  
  if(appStorage.userHasSession()){
    const appJson = JSON.stringify(state.applicationState);
    appStorage.setItem(STORAGEKEYS.APPLICATION_STATE, appJson);

    const consentJSON = JSON.stringify(state.consentState);
    sessionStorage.add(STORAGEKEYS.CONSENT_STATE, consentJSON);
    
    //Lentos
    const offertJSON = JSON.stringify(state.offertState)
    appStorage.setItem(STORAGEKEYS.OFFER_STATE, offertJSON)
    
    const textContentsJSON = JSON.stringify(state.textContentsState)
    sessionStorage.add(STORAGEKEYS.TEXT_CONTENTS_STATE, textContentsJSON)

    const lenConfigJSON = JSON.stringify(state.lenConfigState)
    sessionStorage.add(STORAGEKEYS.LEN_CONFIG_STATE, lenConfigJSON)

    const contractSignStateJSON = JSON.stringify(state.contractSignState)
    sessionStorage.add(STORAGEKEYS.CONTRACT_SIGN_STATE, contractSignStateJSON)

    const loanCalculatorJSON = JSON.stringify(state.loanCalculatorState)
    sessionStorage.add(STORAGEKEYS.LOAN_CALCULATOR_STATE, loanCalculatorJSON)//TODO SPRAWDZIĆ CZY SESSION STATE CZY STATE

    const formJSON = JSON.stringify(state.formState)
    sessionStorage.add(STORAGEKEYS.FORM_STATE, formJSON)

    const videoVerificationJSON = JSON.stringify(state.videoVerificationState)
    sessionStorage.add(STORAGEKEYS.VIDEO_VERIFICATION_STATE, videoVerificationJSON)
  }
}

function getState<T>(key: string, storage : AppStorage, initialState : T) : T{
  if(storage.isKeyExists(key) && storage.userHasSession()){
  const stateJson = storage.getItem(key);
  const result = JSON.parse(stateJson);
    return result as unknown as T;
  }
  return initialState as T;
}
function getSessionState<T>(key: string, initialState : T){
  const sessionStorage = new SessionStorage();
  const stateJson = sessionStorage.get(key);
  let state = initialState;
  if(stateJson != null && stateJson){
    state = JSON.parse(stateJson);
  }
  return state;
}

const loadState = () =>{
  const appStorage = new AppStorage();
  const applicationState = getState(STORAGEKEYS.APPLICATION_STATE, appStorage, initialApplicationState)
  const offertState = getState(STORAGEKEYS.OFFER_STATE, appStorage, offertInitialState)
  const textContentsState = getSessionState(STORAGEKEYS.TEXT_CONTENTS_STATE, defaultTextContents)
  const lenConfigState = getSessionState(STORAGEKEYS.LEN_CONFIG_STATE, lenConfigInitialState)
  const contractSignState = getSessionState(STORAGEKEYS.CONTRACT_SIGN_STATE, contractSignIntialState)
  const consentState = getSessionState(STORAGEKEYS.CONSENT_STATE, intialStateConsent);
  const formState = getSessionState(STORAGEKEYS.FORM_STATE, formInitialState)
  const loanCalculatorState = getSessionState(STORAGEKEYS.LOAN_CALCULATOR_STATE, loanCalculatorInitialState)
  const videoVerificationState = getSessionState(STORAGEKEYS.VIDEO_VERIFICATION_STATE, videoVerificationInitialState)

  return {
    contractSignState : contractSignState,
    applicationState : applicationState,
    consentState: consentState,
    offertState: offertState,
    textContentsState: textContentsState,
    lenConfigState: lenConfigState,
    formState: formState,
    loanCalculatorState: loanCalculatorState,
    videoVerificationState: videoVerificationState,
  }
}


export const store = configureStore({
  reducer: combineReducers({
    contractSignState : contractSignReducer,
    applicationState : applicationReducer,
    consentState : consentReducer,
    offertState: offerReducer,
    textContentsState: textContentReducer,
    lenConfigState: lenConfigReducer,
    formState: formReducer,
    loanCalculatorState: loanCalculatorReducer,
    videoVerificationState: videoVerificationReducer,
  }),
  preloadedState: loadState(),
})

registerInvalidDocumentNumbersConfig(() => store.getState().lenConfigState.globalConfig)

// Infer the `RootState` and `AppDispatch` types from the store itself
export type AppState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export const apphistory = createBrowserHistory();
